export default __webpack_public_path__ + "static/media/selectPic.307f1906.svg";